import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetThemeQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetThemeQuery = { __typename?: 'Query', getTheme: string };


export const GetTheme = /*#__PURE__*/ gql`
    query GetTheme {
  getTheme
}
    ` as unknown as DocumentNode<GetThemeQuery, GetThemeQueryVariables>;

          

          export const useGetThemeQuery = (options?:QueryHookOptions<GetThemeQuery, GetThemeQueryVariables>) => useQuery(GetTheme, options);

          

          export type GetThemeQueryOptions = QueryHookOptions<GetThemeQuery, GetThemeQueryVariables>;

          

          export const useGetThemeLazyQuery = (options?:LazyQueryHookOptions<GetThemeQuery, GetThemeQueryVariables>) => useLazyQuery(GetTheme, options);

          

          export type GetThemeQueryResult = ReturnType<typeof useGetThemeQuery>;

          
